import { combineReducers } from 'redux';

import { ApiReducerKey } from 'constants/index';

import detail from './detail';

export default combineReducers({ [ApiReducerKey.DETAIL]: detail });
